import { MerchantService } from './../../../../../_services/merchant.service';
import { IntegrationService } from './../../../../../_services/integration.service';
import { Component, inject, OnInit } from '@angular/core';
import { ConfigurationService } from '../../../../../_services/configuration.service';

export interface EndPoints {
  soluzione: string;
  collaudo: object;
}

@Component({
  selector: 'app-configurations-solutions',
  templateUrl: './configurations-solutions.component.html',
  styleUrls: ['./configurations-solutions.component.scss'],
  standalone: false
})

export class ConfigurationsSolutionsComponent implements OnInit {
  private readonly integrationService: IntegrationService = inject(IntegrationService);
  private readonly merchantService: MerchantService = inject(MerchantService);
  private readonly configurationService: ConfigurationService = inject(ConfigurationService);

  qry: Array<object>;
  accessEndpoint: string;
  merchantID: string;
  licenseObj: any;
  host: string = '{{host}}';

  displayedColumns = { soluzione: $localize`:@@th-Solution:Soluzioni`, collaudo: $localize`:@@th-Testing:Collaudo` };

  endpointsTest: EndPoints[] = [
    { soluzione: 'API Checkout', collaudo: { url: `${this.host}`, icon: 'open-in-new-tab' } },
    { soluzione: 'EASY', collaudo: { url: `${this.host}/sdk`, icon: 'open-in-new-tab' } },
    { soluzione: 'SMART', collaudo: { url: `${this.host}/sdk`, icon: 'open-in-new-tab' } },
    { soluzione: 'In-App IOS', collaudo: { url: `${this.host}`, icon: 'open-in-new-tab' } },
    { soluzione: 'In-App ANDROID', collaudo: { url: `${this.host}`, icon: 'open-in-new-tab' } }
  ];

  constructor() {
    this.configurationService.accessEnv$.subscribe((env) => {
      this.accessEndpoint = env;
    })
    this.merchantID = this.merchantService.currentMerchant._id;
    this.qry = [{ key: 'merchant', value: this.merchantID }];
    this.integrationService.filterIntegrationsByQuery(this.qry).subscribe((data: any) => {
      if (data?.items) {
        this.licenseObj = data.items;
      }
    });
  }

  ngOnInit(): void {
    this.setHost();
  }

  setHost() {
    this.configurationService.getPublicSettings().subscribe((data: any) => {
      this.host = data?.settings?.host || this.host;

      this.endpointsTest = [
        { soluzione: 'API Checkout', collaudo: { url: `${this.host}`, icon: 'open-in-new-tab' } },
        { soluzione: 'EASY', collaudo: { url: `${this.host}/sdk`, icon: 'open-in-new-tab' } },
        { soluzione: 'SMART', collaudo: { url: `${this.host}/sdk`, icon: 'open-in-new-tab' } },
        { soluzione: 'In-App IOS', collaudo: { url: `${this.host}`, icon: 'open-in-new-tab' } },
        { soluzione: 'In-App ANDROID', collaudo: { url: `${this.host}`, icon: 'open-in-new-tab' } }
      ];
    });
  }

  redirect() {
    const url = this.configurationService.normalizeAccessEndpoint(this.accessEndpoint, this.host);

    if (!this.accessEndpoint) console.log('no access endpoint found');
    window.open(url, '_blank');
  }
}
